module.exports = __webpack_public_path__ + "static/hero-478c93ef2e796d0c24661fa60894294a.png";